// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"652ea28e","67":"f9d14d57","71":"617d9ace","113":"5747091c","202":"8de1cc41","312":"c8367d30","475":"43e82c62","490":"2a0563d4","503":"47abd272","576":"f2fad667","665":"52a3e5d3","837":"4cc848b5"}[chunkId] + ".chunk.js";
};